const lockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'hidden';
};

const unlockScroll = () => {
  const body = document.querySelector('body');
  body.style.overflow = 'auto';
};

export { lockScroll, unlockScroll };
